<template> 
  <div id="app" style="height:100%">
  
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
     <router-view />
  </div>
</template>
 <script>
 
export default {
  name: "App",
  data() {
    return {
      keyWords: "",
    };
  },
  methods: {
     
  },
  mounted: function () {
    
  },
  components: {
    
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  font-size:40px ;
  fill: currentColor;
  overflow: hidden; 
}

</style>
